<template>
  <div class="wrap">
    <div id="primary" class="content-area">
      <main class="site-main">
        <article class="page type-page status-publish hentry">
          <div class="entry-content">
            <h1>{{ $t('about.text_0') }}</h1>
            <p>
              <img
                class="size-full aligncenter"
                src="images/about.png"
              >
            </p>
            <div>{{ $t('about.text_1') }}</div>
            <div></div>
            <ol style="margin-left: 20px; margin-top:20px;">
              <li>{{ $t('about.text_2') }}</li>
              <li>{{ $t('about.text_3') }}</li>
              <li>
                {{ $t('about.text_4') }}
                <ol style="list-style-type: upper-alpha;">
                  <li>{{ $t('about.text_5') }}</li>
                  <li>{{ $t('about.text_6') }}</li>
                  <li>{{ $t('about.text_7') }}</li>
                  <li>{{ $t('about.text_8') }}</li>
                </ol>
              </li>
            </ol>
            <p>{{ $t('about.text_9') }}</p>
            <p>{{ $t('about.text_10') }}</p>
          </div>
        </article>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    document.body.className = "page-template-default page page-one-column colors-light";
  }
};
</script>

<style lang="stylus" scoped>
.entry-content {
  div, p, li {
    text-align: justify;
  }
}
</style>
